export class RefreshRequest {
  refresh: string;

  constructor(refresh: string) {
    this.refresh = refresh;
  }
}
